import { environment } from "src/environments/environment.generated";

export function calculateHowTimesBefore(dateTimeRFC: string, lang: string = 'en') {
    const currentDate = new Date();
    const currentTimestamp: number = currentDate.getTime();

    const langBasedObj: any = {
        en: ['years ago', 'months ago', 'days ago', 'hours ago', 'minutes ago', 'seconds ago'],
        de: ['Jahre zuvor', 'Vor wenigen Monaten', 'Vor Tagen', 'Vor Stunden', 'Vor ein paar Minuten', 'Sekunden zuvor']
    };

    const dateTimeParts = dateTimeRFC.split(' ');
    const timeParts = dateTimeParts[1].split(':');
    const secondParts = timeParts[2].split('.');
    const dateParts = dateTimeParts[0].split('-');

    const comingDateStr = dateParts[1]+'/'+dateParts[2]+'/'+dateParts[0]+' '+timeParts[0]+':'+timeParts[1]+':'+secondParts[0]+' UTC';

    const comingDate = new Date(comingDateStr);
    const comingDateTimestamp = comingDate.getTime();

    const seconds: number = Math.floor(currentTimestamp / 1000) - Math.floor(comingDateTimestamp / 1000);

    let interval = seconds / 31536000;

    if(interval > 1) {
        return `${Math.floor(interval)} ${langBasedObj[lang][0]}`;
    }

    interval = seconds / 2592000;
    if(interval > 1) {
        return `${Math.floor(interval)} ${langBasedObj[lang][1]}`;
    }

    interval = seconds / 86400;
    if(interval > 1) {
        return `${Math.floor(interval)} ${langBasedObj[lang][2]}`;
    }

    interval = seconds / 3600;
    if(interval > 1) {
        return `${Math.floor(interval)} ${langBasedObj[lang][3]}`;
    }

    interval = seconds / 60;
    if(interval > 1) {
        return `${Math.floor(interval)} ${langBasedObj[lang][4]}`;
    }
    return `${Math.floor(seconds)} ${langBasedObj[lang][5]}`;
}

export function getAppThemeName() {
    return environment.brand;
}

export function getCookie(name: string) {
    let ca: Array<string> = document.cookie.split(';');
    let caLen: number = ca.length;
    let cookieName = `${name}=`;
    let c: string;

    for (let i: number = 0; i < caLen; i += 1) {
        c = ca[i].replace(/^\s+/g, '');
        if (c.indexOf(cookieName) == 0) {
            return c.substring(cookieName.length, c.length);
        }
    }
    return '';
}

export function setCookie(name: string, value: string, expireDays: number, path: string = '') {
    let d:Date = new Date();
    d.setTime(d.getTime() + expireDays * 24 * 60 * 60 * 1000);
    let expires:string = `expires=${d.toUTCString()}`;
    let cpath:string = path ? `; path=${path}` : '';
    document.cookie = `${name}=${value}; ${expires}${cpath}`;
}
